export default function storePrintForm(categoryDataEl, templateDataEl) {

    const allCategories = utils.getJsonScript(categoryDataEl)
    const allTemplates = utils.getJsonScript(templateDataEl)

    function getInitialCategory() {
        return Number(new URLSearchParams(location.search).get('category_id'))
    }

    return {
        allCategories,
        allTemplates,
        selectedCategoryId: getInitialCategory(),
        selectedTemplateId: null,
        getCategoryImage() {
            const selectedCategory = this.getSelectedCategory()
            return selectedCategory ? selectedCategory.image : ''
        },
        getSelectedCategory() {
            return this.getCategoryById(this.selectedCategoryId)
        },
        getCategoryById(id) {
            return this.allCategories.find(category => category.id == id)
        },
        getAvailableTemplates() {
            return allTemplates.filter(template => template.category_id == this.selectedCategoryId)
        },
        getTemplateImage() {
            const template = this.getSelectedTemplate()
            return template ? template.image : ''
        },
        getSelectedTemplate() {
            return this.getTemplateById(this.selectedTemplateId)
        },
        getTemplateById(id) {
            return this.allTemplates.find(template => template.id == id)
        },
        getTemplateCardStyle(template) {
            return `background-image:url('${template.image}');`
        }
    }
}